const ListItemOrder = props => {
  const { children } = props;
  return <span className="r-list__item-order">{children}</span>;
};

export default ListItemOrder;
